import Vue from 'vue';

import { store } from '../vuex/store';
import { routes } from './routes';
import VueRouter from 'vue-router';
Vue.use( VueRouter );

const router = new VueRouter({

  mode: 'history',
  routes
});

router.beforeEach( ( to, from, next ) => {

  if( to.query.jwt ){

    console.log( 'got here to auth JWT', to.query.jwt );
    store.dispatch( 'auth/authUsingJwt', to.query.jwt );
  } // else console.log( 'no jwt in query..' );

  if( [ 'home' ].includes( to.name ) && [ 'order-menu' ].includes( from.name ) ){

    store.dispatch( 'orderMenu/clearState' );
  }

  switch( to.name ){

    case 'signin':

      store.dispatch( 'nav/hideHeader' );
      if( store.getters[ 'auth/isAuth' ] ){

        next( '/home' )
      } else next();
      break;
    case 'home':

      if( store.getters[ 'auth/isAuth' ] && store.getters[ 'merchant/currentLocation' ] == null ){

        store.dispatch( 'nav/hideHeader' );
        next( '/merchantLocation' );
      } else if( !store.getters[ 'auth/isAuth' ] ){

        next( '/signin' )
      } else {

        store.dispatch( 'nav/showHeader' );
        next();
      }
      break;
    case 'order-menu'    :
    case 'order-history' :
    case 'view-order'    :
    case 'in-app-msg'    :
    case 'view-msg'      :
    case 'transactions'  :
    case 'manage-cards'  :
    case 'profile'       :

      if( store.getters[ 'auth/isAuth' ] && store.getters[ 'merchant/currentLocation' ] == null ){

        store.dispatch( 'nav/hideHeader' );
        store.dispatch( 'nav/saveIntendedRoute', to.name );
        next( '/merchantLocation' );
      } else if( !store.getters[ 'auth/isAuth' ] ){

        next( '/signin' )
      } else {

        store.dispatch( 'nav/hideHeader' );
        next();
      }
      break;
    default:

      if( !store.getters[ 'auth/isAuth' ] ){

        next( '/signin' );
      } else {

        store.dispatch( 'nav/hideHeader' );
        next();
      }
      break;
  }
});

router.afterEach( ( to, from ) => {

  store.dispatch( 'updateNavigation', { to, from } );
})
export default router;